/**
 * The compact order-status pill shown on every fan screen outside the
 * ordering view: which label to show and how loud to be.
 */
export type OrderPillKey =
  | 'processing'
  | 'received'
  | 'ready'
  | 'delivered'
  | 'collected'
  | 'cancelled'
  | 'refunded';

export type OrderPillTone = 'neutral' | 'ready' | 'done' | 'alert';

export function orderPillState(status: string, paymentStatus: string | null | undefined): { key: OrderPillKey; tone: OrderPillTone } {
  // Refunded first: a refunded order is usually also cancelled, and the money
  // coming back is what the fan cares about.
  if (paymentStatus === 'refunded') return { key: 'refunded', tone: 'alert' };
  switch (status) {
    case 'pending_payment': return { key: 'processing', tone: 'neutral' };
    case 'ready_at_collection_point': return { key: 'ready', tone: 'ready' };
    case 'delivered': return { key: 'delivered', tone: 'done' };
    case 'collected': return { key: 'collected', tone: 'done' };
    case 'cancelled': return { key: 'cancelled', tone: 'alert' };
    default: return { key: 'received', tone: 'neutral' };
  }
}
